import PublicDialog from '../index/components/public-dialog/index-rt'
import CodeEdit from '../index/components/code-edit'
// import ServiceEdit from '../index/components/service-edit/index'
// import IconSelect from '../index/components/icon-select'
import MWInnerView from '../index/components/MwInnerView'
// import DataModelEditor from '../index/components/data-model-editor';
import flowChartViewer from '../index/components/flow-chart-viewer'
import DoubleFace from '../index/components/double-face'
import MwServiceConsole from '../index/components/service-edit/serviceConsole'
import personalGroup from '../index/views/systemSet/org/personalGroup'
import personalOuterOrg from '../index/views/systemSet/org/personalOuterOrg'

import systemSet_form_edit from '../index/views/formEdit/common/Form'
import systemSet_flow_edit from '../index/views/formEdit/flow/Flow'

const components = [
  PublicDialog,
  CodeEdit,
  // ServiceEdit,
  // IconSelect,
  MWInnerView,
  DoubleFace,
  // DataModelEditor,
  MwServiceConsole,
  personalGroup,
  personalOuterOrg,
  systemSet_form_edit,
  systemSet_flow_edit,
  flowChartViewer
];

const install = {
  install: function (Vue) {
    components.map(component => {
      Vue.component(component.name, component);
    });
    Vue.component('mw-code-editor',CodeEdit)
  }
}

// 导出组件
export default install



// WEBPACK FOOTER //
// ./src/modules/contrib/components.js